<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 27.4">
    <path
      d="M25.1 16.6v5.7c0 1.4-.5 2.6-1.5 3.6s-2.2 1.5-3.6 1.5H5.1c-1.4 0-2.6-.5-3.6-1.5S0 23.7 0 22.3V7.4C0 6 .5 4.8 1.5 3.8s2.2-1.5 3.6-1.5h12.6c.2 0 .3.1.4.2.1.1.2.2.2.4V4c0 .2-.1.3-.2.4s-.2.2-.4.2H5.1c-.8 0-1.5.3-2 .8s-.8 1.2-.8 2v14.9c0 .8.3 1.5.8 2 .6.6 1.2.8 2 .8H20c.8 0 1.5-.3 2-.8.6-.6.8-1.2.8-2v-5.7c0-.2.1-.3.2-.4.1-.1.2-.2.4-.2h1.1c.2 0 .3.1.4.2.2.1.2.2.2.4zM32 1.1v9.1c0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.8-.3L27 7.9 15.3 19.6c-.1.1-.3.2-.4.2s-.3-.1-.4-.2l-2-2c-.1-.1-.2-.3-.2-.4 0-.2.1-.3.2-.4L24.1 5.1 21 2c-.2-.2-.3-.5-.3-.8s.1-.6.3-.8c.1-.3.4-.4.7-.4h9.1c.3 0 .6.1.8.3.3.3.4.5.4.8z" />
  </svg>
</template>

<script setup></script>
